var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityIconInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0009 28.2758C22.3332 28.2758 28.2773 22.3318 28.2773 14.9995C28.2773 7.66716 22.3332 1.72314 15.0009 1.72314C7.66862 1.72314 1.72461 7.66716 1.72461 14.9995C1.72461 22.3318 7.66862 28.2758 15.0009 28.2758Z",
    fill: "#1D202B",
    stroke: "#585C6B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32016 20.1057C7.26815 20.1057 8.17731 19.7292 8.84764 19.0588C9.51797 18.3885 9.89456 17.4793 9.89456 16.5313V13.4676C9.89456 12.5196 10.2711 11.6104 10.9415 10.9401C11.6118 10.2698 12.521 9.89318 13.469 9.89318C14.4169 9.89318 15.3261 9.5166 15.9964 8.84627C16.6668 8.17594 17.0433 7.26678 17.0433 6.31879V1.87928C16.3776 1.77648 15.6955 1.72314 15.0009 1.72314C7.66862 1.72314 1.72461 7.66716 1.72461 14.9995C1.72461 16.8089 2.0866 18.5338 2.74211 20.1057H6.32016Z",
    fill: "#1D202B",
    stroke: "#585C6B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2745 14.7948C27.2522 14.2647 26.1185 13.9849 24.9669 13.9785H20.6164C19.6684 13.9785 18.7592 14.3551 18.0889 15.0254C17.4186 15.6958 17.042 16.6049 17.042 17.5529C17.042 18.5009 17.4186 19.4101 18.0889 20.0804C18.7592 20.7507 19.6684 21.1273 20.6164 21.1273C21.2935 21.1273 21.9429 21.3963 22.4217 21.8751C22.9005 22.3539 23.1695 23.0033 23.1695 23.6804V25.4574H23.1798C26.263 23.0423 28.2513 19.2932 28.2758 15.0787V14.9208C28.2756 14.8788 28.2751 14.8368 28.2745 14.7948Z",
    fill: "#1D202B",
    stroke: "#585C6B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityIconInactive);
export default __webpack_public_path__ + "static/media/community-icon-inactive.2b3ed1276cc058830382494f786bd5ab.svg";
export { ForwardRef as ReactComponent };